import { useQuery } from '@tanstack/react-query';
import { PricingClient } from 'src/WebApiController';

import { useAppContext } from '../AppContext';
import { ErrorTypes, useClientLogContext } from '../ClientLogContext';

export const useGetVenueZoneMapConfigInfo = (
  eventId?: number | null,
  configId?: number | null,
  disabled?: boolean
) => {
  const { activeAccountWebClientConfig } = useAppContext();

  const { trackError } = useClientLogContext();

  const shouldQuery =
    !disabled &&
    activeAccountWebClientConfig.activeAccountId != null &&
    eventId != null &&
    configId != null;

  const venueMapZoneInfoQuery = useQuery({
    queryKey: [
      'PricingClient.GetVenueMapZoneConfigInfo',
      activeAccountWebClientConfig.activeAccountId,
      eventId,
      disabled,
    ],
    queryFn: async () => {
      if (!shouldQuery) {
        return null;
      }

      const venueMapZoneInfo = await new PricingClient(
        activeAccountWebClientConfig
      ).getVenueMapZoneConfigInfo(eventId!, configId!);

      return venueMapZoneInfo;
    },

    enabled: shouldQuery,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    meta: {
      persist: true,
      onError: (error: ErrorTypes) => {
        trackError('PricingClient.GetVenueMapZoneConfigInfo', error, {
          eventId,
          configId,
        });
      },
    },
  });

  return venueMapZoneInfoQuery;
};
